export type Policy = any

export interface PoliciesState {
    loading: boolean
    loadingdata: boolean
    resultpolicy: string | null
    policies: Policy[]
    policiesForSelect: Policy[]
    policy: Policy | null
    total: number
}

const initialState: PoliciesState = {
    loading: false,
    loadingdata: false,
    resultpolicy: null,
    policies: [],
    policiesForSelect: [],
    policy: null,
    total: 0,
}

export const policiesReducer = (state: PoliciesState = initialState, action: { type: string; payload?: any }): PoliciesState => {
    switch (action.type) {
        case "POLICY_GETALL_SUCCESS":
            return {
                ...state,
                loading: false,
                policies: action.payload.policies as Policy[],
                total: action.payload.total,
                resultpolicy: null,
            }

        case "POLICY_GETALLFORSELECT_SUCCESS":
            return {
                ...state,
                policiesForSelect: action.payload as Policy[],
                loading: false,
                resultpolicy: null,
            }

        case "POLICY_GET_SUCCESS":
            return {
                ...state,
                loading: false,
                policy: action.payload.policy as Policy,
            }

        case "POLICY_RESET_RESULT":
            return {
                ...state,
                resultpolicy: null,
            }

        case "POLICY_EDIT_SUCCESS":
            return {
                ...state,
                loading: false,
                resultpolicy: action.payload.message as string
            }

        case "POLICY_LOADING":
            return {
                ...state,
                loading: true,
            }

        case "POLICY_NOT_LOADING":
            return {
                ...state,
                loading: false,
            }

        case "POLICYDATA_GET_SUCCESS":
            return {
                ...state,
                loadingdata: false,
                policy: action.payload.policy as Policy,
            }

        case "POLICYDATA_LOADING":
            return {
                ...state,
                loadingdata: true,
            }

        case "POLICYDATA_NOT_LOADING":
            return {
                ...state,
                loadingdata: false,
            }

        default:
            return state
    }
}
